module.exports = __webpack_public_path__ + "static/animal-welfare-38ae092201564d56797f4de15c221574.svg";